// @flow

import * as React from 'react'
import Select from 'react-select'
import styled, { css } from 'styled-components'
import Strings from '@/constants'
import dropdownStyles, { customComponents } from './dropdown-styles'
import styles from './styles.scss'
import gStyles from '@/../styles/main.scss'

const { error: errorColor, inputWidthDesktop, desktopMin, tabletMin } = styles

type DropdownProps = {|
  value: *,
  onChange: (value: *) => void,
  options: OptionsType<*>,
  ariaLabel: string,
  placeholder: string,
  name: string,
  label?: string,
  error?: ?string,
  disabled?: boolean,
  fullWidth?: boolean,
|}

const StyledReact = styled(Select)`
  ${props =>
    props.error &&
    css`
      > div {
        border-bottom-color: ${errorColor};
      }
    `}
  ${props =>
    props.fullWidth &&
    css`
      @media (min-width: ${tabletMin}) {
        width: ${inputWidthDesktop};
      }
      @media (min-width: ${desktopMin}) {
        width: ${inputWidthDesktop};
      }
    `}
`

export class Dropdown extends React.Component<DropdownProps> {
  static defaultProps = {
    label: '',
    error: null,
    disabled: false,
    fullWidth: false,
  }

  renderError = () => {
    const { error } = this.props
    if (error) {
      return <span className={styles.error}>{error}</span>
    }
    return null
  }

  render() {
    const {
      ariaLabel,
      name,
      label,
      placeholder,
      value,
      onChange,
      options,
      error,
      disabled,
      fullWidth,
    } = this.props
    return (
      <div className={styles.flexRow}>
        <div className={styles.label}>
          <div className={gStyles.flexOne}>
            <p>{label}</p>
          </div>
        </div>
        <StyledReact
          id={name.replace(/ /g, '')}
          className={styles.dropdown}
          styles={dropdownStyles}
          aria-label={ariaLabel}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          options={options}
          components={customComponents}
          error={error}
          isDisabled={disabled}
          noOptionsMessage={options.length === 0 ? Strings.noOptionsMessage : Strings.noLocationResults}
          fullWidth={fullWidth}
          label={label}
        />
        {this.renderError()}
      </div>
    )
  }
}

export default Dropdown
